import React, { PropTypes } from 'react';
import { Link } from 'react-router';
import { connect } from 'react-redux';
import actions from 'actions';

const {
  loadUsersWebinarsSaga
} = actions;

class CpdLocker extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      webinars: [1,2,3]
    }
  }

  render() {
    const is_recorded = !!window.location.pathname.match(/recorded/);
    return (
      <main className="site--width">
        <div className="container_cpd row">
          <h2 className="main_title">
            {
              is_recorded ?
              'RECORDED WEBINARS VIEWED' :
              'LIVE WEBINARS ATTENDED'
            }
          </h2>
          <div className="container_tabs col s12">
            <ul className="tabs cpd_tabs">
              <li className="tab col s2">
                <Link activeClassName={'active'} to="/cpd/live">Webinars Attended - Live</Link>
              </li>
              <li className="tab col s2">
                <Link activeClassName={'active'} to="/cpd/recorded">Webinars Viewed - Recorded</Link>
              </li>
            </ul>
          </div>
          {this.props.children}
        </div>
      </main>
    )
  }
}

const mapStateToProps = (state) => ({});
const mapDispatchToProps = (dispatch) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(CpdLocker);



/** WEBPACK FOOTER **
 ** ./src/containers/CpdLocker/CpdLocker.js
 **/